import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import equal from 'deep-equal';
import { getQueryObject } from '../../utils/url';
import SearchBar from '../SearchBar/SearchBar';
import Card from '../Card/Card';
import Body from '../Body/Body';
import * as adobe from '../../utils/adobe';
import { searchDocuments } from '../../actions/document';
import { setNavigatedOnClient } from '../../actions/location';
import SearchResults from './SearchResults';

const fetchData = (props) => {
  const {
    query,
    page = '1',
  } = getQueryObject(props.location.search);

  if (!query) return;

  const results = props.searchResults[query];
  if (!results || (!results.error && !results.itemsByPage[page])) {
    props.searchDocuments({ query, page });
  }
};

const meta = [
  { name: 'description', content: 'Search the Mendeley academic library to find research papers and other publications related to your research field.' },
  { name: 'keywords', content: 'academic software, research papers, bibliography, digital library, research tool, researcher, academics, library management, reference software, library software, academic research' }
];

class SearchResultsContainer extends Component {
  componentWillMount() {
    fetchData(this.props);
  }

  componentDidMount() {
    if (this.props.navigatedOnClient) {
      adobe.trackSearchResultsPageView();
    } else {
      this.props.setNavigatedOnClient();
    }
  }

  shouldComponentUpdate(props) {
    return !equal(props, this.props);
  }

  componentWillUpdate(props) {
    fetchData(props);
  }

  render() {
    const {
      location: { search },
      searchResults,
      documents,
    } = this.props;

    const {
      query,
      page = '1',
    } = getQueryObject(search);

    return (
      <div>
        <Helmet
          title="Search"
          meta={meta}
        />
        <SearchBar />
        <Body>
          {!query && (
            <Card
              data-name="no-query"
              fullHeight
            />
          )}
          {query && (
            <SearchResults
              query={query}
              page={parseInt(page, 10)}
              results={searchResults[query]}
              documents={documents}
            />
          )}
        </Body>
      </div>
    );
  }
}

const mapStateToProps = ({
  searchResults,
  documents,
  location,
}) => ({
  searchResults,
  documents,
  navigatedOnClient: location.navigatedOnClient,
  updatedSearchResultsOnClient: location.updatedSearchResultsOnClient,
});

const mapDispatchToProps = {
  searchDocuments,
  setNavigatedOnClient,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsContainer);



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/SearchResultContainer.js